import { formatNonTaxableTaxKey, formatTaxKey } from '../../helpers';
import { TaxType, NonTaxableTaxType, TaxOptions } from '../../types';

export const ipsiTaxOptions: TaxOptions = {
  [formatTaxKey(TaxType.IPSI, 0)]: {
    label: '0% IPSI',
    amount: 0,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 0),
  },
  [formatNonTaxableTaxKey(TaxType.IPSI, NonTaxableTaxType.Exempt, 0)]: {
    label: `Exenta`,
    amount: 0,
    type: TaxType.IPSI,
    value: formatNonTaxableTaxKey(TaxType.IPSI, NonTaxableTaxType.Exempt, 0),
    salesEqTaxPercentage: 0,
  },
  [formatNonTaxableTaxKey(TaxType.IPSI, NonTaxableTaxType.NotSubject, 0)]: {
    label: `No sujeta`,
    amount: 0,
    type: TaxType.IPSI,
    value: formatNonTaxableTaxKey(
      TaxType.IPSI,
      NonTaxableTaxType.NotSubject,
      0
    ),
    salesEqTaxPercentage: 0,
  },
  [formatNonTaxableTaxKey(TaxType.IPSI, NonTaxableTaxType.ReverseCharge, 0)]: {
    label: `Inv. Suj.`,
    amount: 0,
    type: TaxType.IPSI,
    value: formatNonTaxableTaxKey(
      TaxType.IPSI,
      NonTaxableTaxType.ReverseCharge,
      0
    ),
    salesEqTaxPercentage: 0,
  },
  [formatTaxKey(TaxType.IPSI, 0.5)]: {
    label: '0,5% IPSI',
    amount: 0.5,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 0.5),
  },
  [formatTaxKey(TaxType.IPSI, 0)]: {
    label: '0% IPSI',
    amount: 0,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 0),
  },
  [formatTaxKey(TaxType.IPSI, 1)]: {
    label: '1% IPSI',
    amount: 1,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 1),
  },
  [formatTaxKey(TaxType.IPSI, 2)]: {
    label: '2% IPSI',
    amount: 2,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 2),
  },
  [formatTaxKey(TaxType.IPSI, 3)]: {
    label: '3% IPSI',
    amount: 3,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 3),
  },
  [formatTaxKey(TaxType.IPSI, 3.5)]: {
    label: '3,5% IPSI',
    amount: 3.5,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 3.5),
  },
  [formatTaxKey(TaxType.IPSI, 4)]: {
    label: '4% IPSI',
    amount: 4,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 4),
  },
  [formatTaxKey(TaxType.IPSI, 5)]: {
    label: '5% IPSI',
    amount: 5,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 5),
  },
  [formatTaxKey(TaxType.IPSI, 6)]: {
    label: '6% IPSI',
    amount: 6,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 6),
  },
  [formatTaxKey(TaxType.IPSI, 7)]: {
    label: '7% IPSI',
    amount: 7,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 7),
  },
  [formatTaxKey(TaxType.IPSI, 8)]: {
    label: '8% IPSI',
    amount: 8,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 8),
    hide: true,
  },
  [formatTaxKey(TaxType.IPSI, 9)]: {
    label: '9% IPSI',
    amount: 9,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 9),
  },
  [formatTaxKey(TaxType.IPSI, 10)]: {
    label: '10% IPSI',
    amount: 10,
    type: TaxType.IPSI,
    value: formatTaxKey(TaxType.IPSI, 10),
  },
};
